// extracted by mini-css-extract-plugin
module.exports = {"AdSlotOffsite":"bgv_a bhs_bi"};